import HttpResponse from "../../../../../../utils/http/http.response";

export enum BillingsOrderRelatedTaxiDriverResponseDataContractBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type BillingsOrderRelatedTaxiDriverResponseDataTaxiTaxiCorporation = {
  displayName: string;
};

export type BillingsOrderRelatedTaxiDriverResponseDataTaxiDriverAssociation = {
  taxiCorporation: BillingsOrderRelatedTaxiDriverResponseDataTaxiTaxiCorporation;
};

export type BillingsOrderRelatedTaxiDriverResponseDataPlanEntry = {
  humanId: string;
};

export type BillingsOrderRelatedTaxiDriverResponseDataContract = {
  taxiDriverAssociation: BillingsOrderRelatedTaxiDriverResponseDataTaxiDriverAssociation;
  distanceRate: number;
  model: BillingsOrderRelatedTaxiDriverResponseDataContractBillingModel;
};

export type BillingsOrderRelatedTaxiDriverResponseData = {
  id: string;
  sumOfBonuses: number;
  sumOfPenalties: number;
  draft: boolean;
  distance: number;
  amountForChargeHighways: number | null;
  amountForChargeHaltings: number | null;
  allContributionsAmount: number | null;
  amountForDistance: number | null;
  date: Date;
  planEntry: BillingsOrderRelatedTaxiDriverResponseDataPlanEntry;
  contract: BillingsOrderRelatedTaxiDriverResponseDataContract;
};

type BillingsOrderRelatedTaxiDriverResponse = HttpResponse<
  BillingsOrderRelatedTaxiDriverResponseData[]
>;

export default BillingsOrderRelatedTaxiDriverResponse;
